export default __webpack_public_path__ + "static/avatar-mp-kayi-male-0-v4-37207817e25422802c80a9e2b3e4c4bc.png";